module.exports = __webpack_public_path__ + "img/CrossyRoadNew.b9f96874.png";